import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';

import { Subscription } from 'rxjs';
import moment from 'moment-timezone';

import { PartyTypes } from '@shared/party/enums';
import { PartyBadge } from '@tablesready/frontend-badge';
import { FloorPlanPartyType } from '@tablesready/frontend-timeline';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';
import { ClockService } from '@tablesready/frontend-alerts-bar';
import { CheckoutStatus } from '@shared/stripe/enums';
import { APP_VARIABLES_TOKEN, AppVariables } from '@tablesready/frontend-variables';

@Component({
  selector: 'tablesready-floorplan-card',
  templateUrl: './floorplan-card.component.html',
  styleUrls: ['./floorplan-card.component.scss'],
})
export class FloorplanCardComponent implements OnInit {
  @Output() cardSelected = new EventEmitter<boolean>();
  @Input() type = FloorPlanPartyType.booked;
  @Input() titleColor = 'blue';
  @Input() resourceName = 'Table #';
  @Input() resourceIds: string[] = [];
  @Input() showStatus = false;
  @Input() customerName = '';
  @Input() quotedTime = 0;
  @Input() seatedTime = 0;
  @Input() duration = 0;
  @Input() checkInTime = 0;
  @Input() partySize = 0;
  @Input() createTime = 0;
  @Input() partyId = '';
  @Input() iconColor: AppIconColor;
  @Input() partyBadge: PartyBadge;
  @Input() timezone = '';
  @Input() isReservation = false;
  @Input() stripeData?: any;

  now = 0;
  icon = AppIcon;
  color = AppIconColor;
  size = AppIconSize;
  partyTypes = PartyTypes;
  floorPlanPartyTypes = FloorPlanPartyType;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly clockService: ClockService,
    @Inject(APP_VARIABLES_TOKEN) private readonly appVariables: AppVariables,
  ) {}

  get unpaid(): boolean {
    return this.isReservation && this.stripeData?.status === CheckoutStatus.inProgress
      && (this.createTime + (this.appVariables.UNPAID_PARTY_LIFETIME * 1000)) > Date.now();
  }

  get paid(): boolean {
    return this.isReservation && this.stripeData?.status === CheckoutStatus.paid;
  }

  ngOnInit(): void {
    const timeSub = this.clockService.clock$
      .subscribe((now) => {
        this.now = now;
      });

    this.subscriptions.add(timeSub);
  }

  get remainingSecondsToPay(): number {
    return this.createTime + (this.appVariables.UNPAID_PARTY_LIFETIME * 1000);
  }
}
